import { store } from 'packages/blu-booking/src/store';
import { setRightClick } from '../store/Calendar';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AppointmentRightClick = (e: MouseEvent, data: any) => {
  e.preventDefault();

  store.dispatch(setRightClick({ ...data, x: e?.clientX, y: e?.clientY }));
};
